import { render } from "./Feedback.vue?vue&type=template&id=36b05cf0&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=36b05cf0&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=1&id=36b05cf0&lang=scss"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\PhuongVangDanh\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b05cf0"]])

export default __exports__